import { FAQ_ROUTE_NAMES, FAQ_PREVIEW_KIND } from "@/apps/faq/faq.routes";
import { goToField } from "@/shared/utils";

export function useFaqGoTo() {
    return {
        goToSectionField(sectionId, fieldId) {
            goToField(
                FAQ_ROUTE_NAMES.projectQuestions,
                FAQ_PREVIEW_KIND.faq,
                fieldId,
                "edit-section",
                sectionId
            );
        },
        goToQuestionField(questionId, fieldId) {
            goToField(
                FAQ_ROUTE_NAMES.projectQuestions,
                FAQ_PREVIEW_KIND.faq,
                fieldId,
                "edit-question",
                questionId
            );
        },
        goToLayoutField(fieldId) {
            goToField(FAQ_ROUTE_NAMES.projectLayout, FAQ_PREVIEW_KIND.faq, fieldId);
        },
    };
}
